import type { IntlShape } from "@formatjs/intl";
import { Form, Select, type SelectProps } from "antd";
import { type DefaultOptionType } from "antd/es/cascader";
import { type Rule } from "antd/es/form";
import { type FilterFunc } from "rc-select/lib/Select";
import React, { useMemo } from "react";
import { getUserDisplayName } from "../../../common/utils/userDisplayName";
import { type UserLimitedList } from "../../generated-axios-client";

const assigneeSelectOptions = (userItems: UserLimitedList[]) => {
  const assigneeOptions = userItems.map((item) => ({
    key: item.id,
    value: item.id,
    label: getUserDisplayName(item),
  }));

  return assigneeOptions;
};

const assigneeSearchHandler: FilterFunc<DefaultOptionType> = (input, option) => {
  const search = input.toLowerCase();
  const value = option?.label?.toString().toLowerCase?.() ?? "";

  return value.includes(search);
};

type AssigneeSelectFormItemProps = {
  intl: IntlShape;
  userItems: UserLimitedList[];
  rules?: Rule[];
  placeholder?: string | boolean;
  selectProps?: SelectProps<string>;
};

export const AssigneeSelectorFormItem = (props: AssigneeSelectFormItemProps) => {
  const { intl, userItems, rules = [], placeholder = false, selectProps } = props;

  const options = useMemo(() => assigneeSelectOptions(userItems), [userItems]);

  return (
    <Form.Item
      name="assignees"
      label={intl.formatMessage({ id: "filter_label_assignee" })}
      rules={rules}
    >
      <Select
        placeholder={placeholder}
        showSearch={true}
        options={options}
        filterOption={assigneeSearchHandler}
        {...selectProps}
      />
    </Form.Item>
  );
};
